// extracted by mini-css-extract-plugin
module.exports = {"type":"Logo_type__T7wNB","icon":"Logo_icon__QFSUL"};